import Page from '../../containers/page/page.js';
import React, {Component} from 'react';
import type {TranslateType, ReduxStatusType} from '../../types.js';
import styles from '../Resources/Resources.module.css';
import stylesC from "../Courses/Courses.module.css";
import { Link } from "react-router-dom";
import translate from '../../config/text';
import Filters from '../Resources/Filters';
import funnel from './assets/funnel.svg';
import funnelBlue from './assets/funnelBlue.svg';
import axios from 'axios'

const NoResultOutput = (props) => {
    return (
        <div className={`${styles.resourcesWrapper} ${styles.noResultsWrapper}`}>
            <p className={`${stylesC.welcomeText} ${styles.noResults} fontTisa`}>{props.t('noResult')}</p>
        </div>
    )
}

const ResourcesWrapper = (props, index) => {
    console.log(props.data)

    return (
        <div className={styles.resourcesWrapper}>
            {props.data.map(resource => {
                return (
                    <div key={index} className={styles.singleResource}>
                        <Link
                            key={resource.id}
                            to={`/resource/${resource.id}`}
                        >
                            <h3 className={styles.singleResourceHeader} key={resource.id}>{resource.title}</h3>
                        </Link>
                        {
                            resource.tags ? <div className={styles.tagWrapper}>
                                {
                                    resource.tags.map(tag => {
                                        return <div key={tag.tid} className={styles.singleTag}><a onClick={props.handleClick} name={tag.tid} className={styles.tagLink} key={tag.tid}>{tag.title}</a></div>})
                                }
                            </div> : null
                        }

                        <div className={styles.resourceTeaser} dangerouslySetInnerHTML={ { __html: resource.body } }></div>
                        <div className={styles.bottomCta}>
                            <Link to={`/resource/${resource.id}`}>
                                Read More
                            </Link>
                            <a href={resource.url} target="_blank" >Find on Wiki</a>
                        </div>
                    </div>
                )
            })}

            {
                props.realData.length > 3 && props.print.length > 3 ?
                    <div>
                        <ul className={styles.resourcesPagination}>
                            {props.pageFirstBtn}
                            {props.renderPrevBtn}
                            {props.renderPageNumbers}
                            {props.renderNextBtn}
                            {props.pageLastBtn}
                        </ul>
                    </div> :
                    null
            }
        </div>
    )
}

const FilterBar = (props) => {
    return (
        <div className={styles.miniNavWrapper}>

            <div className={styles.searchResource}>
                <input id='searchInput' type="text" onChange={props.onChange} />
            </div>

            {props.state.filterSelected.length > 0 || props.state.searchLength > 0 ?
                    <button
                        onClick={props.resetPrint}
                        className={styles.filterReset}
                    >
                        Reset
                    </button> :
                null
            }

            {props.state.filterSelected.length > 0 ?
            <button className={`${styles.filterButton} ${styles.filterButtonBlue}`} onClick={props.onClick}>
                <span className={styles.selectedValue}>{props.state.filterSelected.length}</span>
                <img className={`${styles.funnelBlue} ${styles.funnel}`} src={funnelBlue} alt=""/>
            </button> :
                null
            }

            {props.state.filterSelected.length === 0 ?
                <button className={styles.filterButton} onClick={props.onClick}>
                    <img className={styles.funnel} src={funnel} alt=""/>
                </button> : null
            }
        </div>
    )
}

const Introduction = (props) => {
    return (
        <div className={`${stylesC.coursesPresentation} ${styles.coursesPresentation}`}>
            <p className={`${stylesC.welcomeText} ${styles.welcomeText} fontTisa`}>{props.t('resources')}</p>
        </div>
    )
}


const FiltersForm = (props) => {

    return (
        <form className={styles.formFilter}>
            <div className={styles.topFilter}>
                {
                    props.state.filterSelected.length > 0 || props.state.searchLength > 0 ?
                        <button
                            onClick={props.resetPrint}
                            className={`${styles.filterReset} ${styles.filterResetDesktop}`}
                        >
                            Reset
                        </button> :
                        null
                }
                <div className={styles.searchResource}>
                    <input type="text" onChange={props.handleSearch} />
                </div>
            </div>
            <ul className={styles.filterListWrapper}>
                <Filters
                    filterClick={props.filterClick}
                    handleClick={props.handleClick}
                    state={props.state.flagTag}
                    name={'tag'}
                    data={props.tags}
                    tid={props.tags.id}
                    updateArticles={props.updateArticles}
                    style={props.state.tagSelected}
                    display={props.state.displayFilter === true ? styles.resourcesFilterList : styles.FilterListClosed}
                />
                <Filters
                    handleClick={props.handleClick}
                    state={props.state.flagType}
                    name={'type'}
                    data={props.type}
                    updateArticles={props.updateArticles}
                    style={props.state.typeSelected}
                    display={props.state.displayFilter === true ? styles.filterOpen : styles.filterClosed}
                />
                <Filters
                    handleClick={props.handleClick}
                    name={'related to'}
                    state={props.state.flagRelated}
                    data={props.related}
                    updateArticles={props.updateArticles}
                    style={props.state.relatedSelected}
                    display={props.state.displayFilter === true ? styles.filterOpen : styles.filterClosed}
                />
            </ul>
        </form>
    )
}

const FiltersFormMobile = (props) => {

    return (
        <form className={props.isOn === false ? `${styles.formFilter} ${styles.mobileFiltersOff}` : `${styles.formFilter} ${styles.mobileFiltersOn}`}>
            <div className={styles.filterHeaderMobile}>
                <h4
                    onClick={props.cancelFilters}
                    className={styles.formCancel}
                >
                    Cancel</h4>
                <h1>Filter by:</h1>
            </div>

            <div className={styles.filterListWrapper}>
                <Filters
                    handleClick={props.handleClick}
                    state={props.state.flagTag}
                    name={'tag'}
                    data={props.tags}
                    tid={props.tags.id}
                    updateArticles={props.updateArticles}
                    style={props.state.tagSelected}
                />
                <Filters
                    handleClick={props.handleClick}
                    state={props.state.flagType}
                    name={'type'}
                    data={props.type}
                    updateArticles={props.updateArticles}
                    style={props.state.typeSelected}
                />
                <Filters
                    handleClick={props.handleClick}
                    name={'related to'}
                    state={props.state.flagRelated}
                    data={props.related}
                    updateArticles={props.updateArticles}
                    style={props.state.relatedSelected}
                />
            </div>
            <div className={styles.filterButtonWrapper}>
                <button
                    className={
                        props.print.length === 0 ?
                            styles.insideFilterButtonOff :
                            styles.insideFilterButton
                    }
                    disabled={props.print.length === 0}
                    onClick={props.onClick}
                >
                    {props.print.length === 0 ? 'no results ' : 'view ' + props.print.length}
                    {props.print.length <= 1 ? 'match' : 'matches'}
                </button>
            </div>

        </form>
    )
}

type PropsType = {
    status: ReduxStatusType
};


export class Resources extends Component<PropsType> {
    t: TranslateType
    constructor(props: PropsType) {
        super(props);
        this.state = {
            searchOn: false,
            searchLength: 0,
            search: [],
            routeFlag: true,
            tagFlag: false,
            filterSelected: [],
            tagSelected: [],
            typeSelected: [],
            relatedSelected: [],
            data: this.props,
            defaultData: this.props.data,
            print: this.props.data,
            filters: [],
            isLoaded: this.props.isLoaded,
            isOn: false,
            displayFilter: false,

            currentPage: 1,
            todosPerPage: 6,
            upperPageBound: 3,
            isPrevBtnActive: 'disabled',
            isNextBtnActive: '',
            pageBound: 3,
            current: 0,

            flagTag: false,
            flagType: false,
            flagRelated: false
        };
        this.t = translate(this.props.language);
    }

    componentDidMount(){
        this.props.fetchDataWithRedux();
        window.scrollTo(0, 0);
        axios.get(`https://mdn.github.io/learning-area/javascript/oojs/json/superheroes.json`)
            .then(res => {
                console.log(res.data)
            })
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        // console.log(this.state.tagSelected)
    }

    handleClick = (e) => {
        e.preventDefault();
        window.scrollTo(0, 0);
        let listid = Number(e.target.id);
        this.setState({
            currentPage: listid
        });

        this.setPrevAndNextBtnClass(listid);
    }
    setPrevAndNextBtnClass = (listid) => {
        let totalPage = Math.ceil(this.state.print.length / this.state.todosPerPage);
        this.setState({isNextBtnActive: 'disabled'});
        this.setState({isPrevBtnActive: 'disabled'});
        if(totalPage === listid && totalPage > 1){
            this.setState({isPrevBtnActive: ''});
        }
        else if(listid === 1 && totalPage > 1){
            this.setState({isNextBtnActive: ''});
        }
        else if(totalPage > 1){
            this.setState({isNextBtnActive: ''});
            this.setState({isPrevBtnActive: ''});
        }
    }
    btnLastClick = (e) => {
        let totalPage = Math.ceil(this.state.print.length / this.state.todosPerPage);
        e.preventDefault();
         window.scrollTo(0, 0);
        this.setState({
            currentPage: totalPage,
            isNextBtnActive: 'disabled',
            isPrevBtnActive: '',
        })
    }
    btnFirstClick = (e) => {
        e.preventDefault();
         window.scrollTo(0, 0);
        this.setState({
            currentPage: 1,
            isNextBtnActive: '',
            isPrevBtnActive: 'disabled',
        })
    }
    btnPrevClick = (e) => {
        e.preventDefault();
         window.scrollTo(0, 0);
        if((this.state.currentPage -1)%this.state.pageBound === 0 ){
            this.setState({upperPageBound: this.state.upperPageBound - this.state.pageBound});
            this.setState({lowerPageBound: this.state.lowerPageBound - this.state.pageBound});
        }
        let listid = this.state.currentPage - 1;
        this.setState({ currentPage : listid});
        this.setPrevAndNextBtnClass(listid);
    }
    btnNextClick = (e) => {
        e.preventDefault();
         window.scrollTo(0, 0);
        if((this.state.currentPage +1) > this.state.upperPageBound ){
            this.setState({upperPageBound: this.state.upperPageBound + this.state.pageBound});
            this.setState({lowerPageBound: this.state.lowerPageBound + this.state.pageBound});
        }
        let listid = this.state.currentPage + 1;
        this.setState({ currentPage : listid});
        this.setPrevAndNextBtnClass(listid);
    }

    render() {

        const { data } = this.state.data;
        if(!data) {
            return <div><h1>{this.t('noResult')}</h1></div>
        }else{

            let typeType = [];

            data.map(resource => {
                if (resource.types){
                    resource.types.map(type => {
                        let types =
                            {
                                id: type.tid,
                                title: type.title,
                                vocabulary: type.vocabulary
                            }

                        typeType.push(types);
                    })
                }

                if (resource.tags){
                    resource.tags.map(tag => {
                        let tags =
                            {
                                id: tag.tid,
                                title: tag.title,
                                vocabulary: tag.vocabulary
                            }

                        typeType.push(tags);
                    })
                }

                if (resource.related_to){
                    resource.related_to.map(related => {
                        let relatedTo =
                            {
                                id: related.tid,
                                title: related.title,
                                vocabulary: related.vocabulary
                            }

                        typeType.push(relatedTo);
                    })
                }
            })

            const checkbox = () => {
                let selected = this.state.filterSelected;

                const filtered = data.filter(({ terms_combined }) => selected.every(i => terms_combined.includes(i)))

                this.setState({
                    print: filtered,
                    search: filtered,
                    currentPage: 1,
                })

                if(selected.length === 0){
                    this.setState({
                        print: this.state.defaultData,
                        search: [],
                        currentPage: 1,
                    });
                }

                // checks the checkbox on articles tag click
                this.state.filterSelected.forEach(function(i){
                    document.querySelector("input[name='"+ i +"']").checked = true;
                });
            }


            const updateArticles = (e) => {
                if(e.target.checked){
                    try {
                        let joined = this.state.filterSelected.concat(e.target.name);
                        this.setState({
                            filterSelected: joined,

                        }, () => {
                            checkbox()
                        });
                    } catch (e) {
                        console.log(e);
                    }
                } else {
                    //remove from state array
                    this.setState({
                        filterSelected: this.state.filterSelected.filter((i) => i !== e.target.name)
                    }, () =>{
                        checkbox()
                    })
                }

                uniqueFilterList.map(filter => {
                    if(filter.id === e.target.name){
                        if(filter.vocabulary.includes('tags')){
                            if(!this.state.tagSelected.includes(e.target.name)){
                                let joined = this.state.tagSelected.concat(e.target.name);
                                this.setState({
                                    tagSelected: joined,
                                })
                            } else {
                                this.setState({
                                    tagSelected: this.state.tagSelected.filter((i) => i !== e.target.name)
                                })
                            }
                        } else {
                            this.setState({
                                tagSelected: this.state.tagSelected.filter((i) => i !== e.target.name)
                            })
                        }
                        if(filter.vocabulary.includes('type')){
                            if(!this.state.typeSelected.includes(e.target.name)){
                                let joined = this.state.typeSelected.concat(e.target.name);
                                this.setState({
                                    typeSelected: joined,
                                })
                            } else {
                                this.setState({
                                    typeSelected: this.state.typeSelected.filter((i) => i !== e.target.name)
                                })
                            }
                        }
                        if(filter.vocabulary.includes('related')){
                            if(!this.state.relatedSelected.includes(e.target.name)){
                                let joined = this.state.relatedSelected.concat(e.target.name);
                                this.setState({
                                    relatedSelected: joined,
                                })
                            } else {
                                this.setState({
                                    relatedSelected: this.state.relatedSelected.filter((i) => i !== e.target.name)
                                })
                            }
                        }
                    }
                })
            };


            let uniqueFilterList = [...new Map(typeType.map(o => [o.id, o])).values()]


            let tags = uniqueFilterList.filter(article => article.vocabulary ? article.vocabulary.includes('tags') : null);
            let related = uniqueFilterList.filter(article => article.vocabulary ? article.vocabulary.includes('related') : null);
            let type = uniqueFilterList.filter(article => article.vocabulary ? article.vocabulary.includes('type') : null);

            const showFilters = () => {
                this.setState({isOn: !this.state.isOn})
            }

            const cancelFilters = () => {
                this.setState((prevState) => ({
                    print: this.state.defaultData,
                    filterSelected: [],
                    search: [],
                    searchLength: 0,
                    currentPage: 1,
                    isNextBtnActive: '',
                    isPrevBtnActive: 'disabled',
                    tagSelected: [],
                    typeSelected: [],
                    relatedSelected: [],
                    isOn: false,
                    flagTag: false,
                    flagType: false,
                    flagRelated: false,
                }));
            }

            const isMobile = window.innerWidth <= 767;

            const showResults = (e) => {
                e.preventDefault();
                this.setState({
                    isOn: !this.state.isOn,
                    flagTag:false,
                    flagType:false,
                    flagRelated:false,
                })
            }

            // reset button
            const resetPrint = () => {
                this.setState(
                    {
                    print: this.state.defaultData,
                    filterSelected: [],
                    search: [],
                    searchLength: 0,
                    currentPage: 1,
                    isNextBtnActive: '',
                    isPrevBtnActive: 'disabled',
                    tagSelected: [],
                    typeSelected: [],
                    relatedSelected: [],
                    }
                )
                this.state.filterSelected.forEach(function(i){
                    document.querySelector("input[name='"+ i +"']").checked = false;
                });

                const searchInput = document.querySelector('#searchInput');
                if(searchInput !== null && searchInput.value !== ''){
                    searchInput.value = '';
                }
            }

            //updating articles list on tag click - individual article page
            if(this.state.routeFlag === true){
                let locationState = this.props.route.location.state;

                if(locationState){
                    if(!this.state.filterSelected.includes(locationState.tid)){
                        let joined = this.state.filterSelected.concat(locationState.tid);
                        this.setState({ filterSelected: joined }, () => {
                            this.setState({routeFlag: !this.state.routeFlag})
                            checkbox()
                        })
                    }
                }
            }

            //
            //handles on tag click -resources page
            const handleTag = (e) => {
                if(!this.state.filterSelected.includes(e.target.name)){
                    let joined = this.state.filterSelected.concat(e.target.name);
                    this.setState({ filterSelected: joined }, () => {
                        checkbox()
                    })
                }
            }

            // search bar
            const handleSearch = (e) => {
                let val = e.target.value.toLowerCase();
                console.log(val.toLowerCase())
                let result = [];
                if(this.state.filterSelected.length === 0){
                    result = data.filter(resource => (resource.body.toLowerCase().includes(val) || resource.title.toLowerCase().includes(val) ))
                } else {
                    result = this.state.search.filter(resource => (resource.body.toLowerCase().includes(val) || resource.title.toLowerCase().includes(val) ))
                }

                this.setState((prevState) => ({
                    print: result,
                    searchLength: val.length,
                }));
            }


            const { print, currentPage, todosPerPage,upperPageBound,lowerPageBound,isPrevBtnActive,isNextBtnActive } = this.state;
            // Logic for displaying current print
            const indexOfLastTodo = currentPage * todosPerPage;
            const indexOfFirstTodo = indexOfLastTodo - todosPerPage;
            const currentTodos = print.slice(indexOfFirstTodo, indexOfLastTodo);

            // Logic for displaying page numbers
            const pageNumbers = [];
            for (let i = 1; i <= Math.ceil(print.length / todosPerPage); i++) {
                pageNumbers.push(i);
            }

            const renderPageNumbers = pageNumbers.map(number => {
                if(number === this.state.currentPage){
                    return(
                        <li key={number} className={styles.active} id={number}><a href='#' className='paginationBtn' id={number} onClick={this.handleClick}>{number}</a></li>
                    )
                }
                else if((number < upperPageBound + 1) && number > lowerPageBound){
                    return(
                        <li key={number} id={number}><a href='#' className='paginationBtn' id={number} onClick={this.handleClick}>{number}</a></li>
                    )
                }
            });
            let pageLastBtn = null;
            if(currentPage < currentTodos.length){
                pageLastBtn = <li><a href='#' onClick={this.btnLastClick}> &gt;&gt; </a></li>
            }
            let pageFirstBtn = null;
            if(currentPage > 1){
                pageFirstBtn = <li><a href='#' onClick={this.btnFirstClick}> &lt;&lt; </a></li>
            }
            let renderPrevBtn = null;
            if(isPrevBtnActive === 'disabled') {
                renderPrevBtn = <li className={styles.isPrevBtnActive}><span id="btnPrev"> &lt; </span></li>
            }
            else{
                renderPrevBtn = <li className={styles.isPrevBtnActive}><a href='#' id="btnPrev" onClick={this.btnPrevClick}> &lt; </a></li>
            }
            let renderNextBtn = null;
            if(isNextBtnActive === 'disabled') {
                renderNextBtn = <li className={styles.isNextBtnActive}><span id="btnNext"> &gt; </span></li>
            }
            else{
                renderNextBtn = <li className={styles.isNextBtnActive}><a href='#' id="btnNext" onClick={this.btnNextClick}> &gt; </a></li>
            }

            const filterClick = () => {
                console.log('clicked')
                this.setState({
                    displayFilter: !this.state.displayFilter
                })
            }

            /////////////////////////////////////////////////

            //filter dropdown handler
            const filterDropdown = (e) => {
                if(e.target.id === 'tag'){
                    this.setState({flagTag: !this.state.flagTag})
                }
                if(e.target.id === 'type'){
                    this.setState({flagType: !this.state.flagType})
                }
                if(e.target.id === 'related to'){
                    this.setState({flagRelated: !this.state.flagRelated})
                }
            }

            return (
                <Page>
                    <Introduction t={this.t} />
                    { isMobile ?
                        <FilterBar
                            state={this.state}
                            onChange={handleSearch}
                            resetPrint={resetPrint}
                            onClick={showFilters}
                        />
                    : null }
                    <div className={styles.resourcesContent}>
                        {this.state.print.length !== 0 ?
                            <ResourcesWrapper
                                renderPrevBtn={renderPrevBtn}
                                pageFirstBtn={pageFirstBtn}
                                renderPageNumbers={renderPageNumbers}
                                pageLastBtn={pageLastBtn}
                                renderNextBtn={renderNextBtn}
                                handleClick={handleTag}
                                realData={data}
                                data={currentTodos}
                                print={this.state.print}
                            /> :
                            <NoResultOutput t={this.t} />
                        }
                        {
                            !isMobile ?
                                <FiltersForm
                                    handleClick={filterDropdown}
                                    handleSearch={handleSearch}
                                    state={this.state}
                                    data={data}
                                    resetPrint={resetPrint}
                                    filterSelected={this.state.filterSelected}
                                    tags={tags}
                                    type={type}
                                    related={related}
                                    updateArticles={updateArticles}
                                />
                                    :  <FiltersFormMobile
                                        state={this.state}
                                        handleClick={filterDropdown}
                                        cancelFilters={cancelFilters}
                                        isOn={this.state.isOn}
                                        tags={tags}
                                        type={type}
                                        related={related}
                                        updateArticles={updateArticles}
                                        print={this.state.print}
                                        onClick={showResults}
                                    />
                        }
                    </div>
                </Page>
            )
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/Resources/Resources.js